import React from "react";
import { Box, Container, makeStyles } from "@material-ui/core";
import { mediationFormConfig } from "./formSchema";
import MediationRequestForm from "features/MediationForm/MediationRequestForm";
import { FIELD_TYPES } from "features/MediationForm/validationSchema";

const useStyles = makeStyles((theme) => ({
  page: {
    minHeight: "100vh",
    backgroundColor: theme.palette.background.default,
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(10),
  },
  container: {
    maxWidth: 860,
  },
}));

const MediationRequestPage = () => {
  const classes = useStyles();

  const handleSuccess = (referenceId) => {

    console.info("[MediationPage] Submission successful. Ref:", referenceId);
  };

  return (
    <Box className={classes.page}>
      <Container className={classes.container}>
        <MediationRequestForm onSuccess={handleSuccess} schema={mediationFormConfig} FIELD_TYPES={FIELD_TYPES}/>
      </Container>
    </Box>
  );
};

export default MediationRequestPage;
